import React from 'react';
import { BaseFilter } from 'landing-page/views/filter-bar/FilterBar';

import { Group } from '@client:common/filtering';
import { Icon } from '@client:common/icon';
import { IconButton } from '@client:common/button';
import './FilterChips.light';
import './FilterChips.dark';

interface Props {
  value: { id: number; value: string };
  quoted?: boolean;
  selected?: BaseFilter;
  setSelected?: (value: BaseFilter) => void;
  applyFilter?: (selectedValues: any, group: string) => void;
  group?: string;
}

const FilterChips = (props: Props) => {
  const { value, quoted, selected, setSelected, applyFilter, group } = props;
  const removeItem = (item: { id: number; value: string }) => {
    const array = selected?.selected;
    const index = array.indexOf(item);
    if (index > -1) {
      // only splice array when item is found
      array.splice(index, 1); // 2nd parameter means remove one item only
    }
    applyFilter(array, group);
    setSelected({
      ...selected,
      selected: group !== Group.SEARCH ? array : undefined
    });
  };
  return (
    <div className='chips-data-container'>
      <p className='chips-value' dangerouslySetInnerHTML={{ __html: quoted ? `"${value.value}"` : value.value }} />
      <IconButton
        style='basic'
        color='primary'
        className='close-icon'
        onClick={() => removeItem(value)}>
        <Icon
          style='outlined'
          icon='close' />
      </IconButton>
    </div>
  );
};

export default FilterChips;
